var e,
    r = (e = require("react")) && "object" == typeof e && "default" in e ? e["default"] : e;

exports.forwardRefWithAs = function (e) {
  return r.forwardRef(e);
};